var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.5,
    height: 63.5,
    viewBox: "0 0 63.5 63.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_168319",
    "data-name": "Group 168319",
    transform: "translate(-169.25 -2350.905)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_348",
    "data-name": "Ellipse 348",
    cx: 31,
    cy: 31,
    r: 31,
    transform: "translate(170 2351.655)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "_2561355_check_check_check_check_check",
    "data-name": "2561355_check_check_check_check_check",
    d: "M32.225,6,12.82,25.4,4,16.584",
    transform: "translate(182.888 2368.095)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.6d305aeabb3d5370c21507081e42dae9.svg";
export { ForwardRef as ReactComponent };